const DefaultDischargeConfig: {
    failed_to_onboard: {
        app_overlay_header: string;
        app_overlay_message: string;
        treatment_note: string;
        customer_note: string;
        patient_email_subject: string;
        patient_email_body: string;
        discharge_after_in_days: number;
    };
    episode_closed: {
        app_overlay_header: string;
        app_overlay_message: string;
        treatment_note: string;
        customer_note: string;
        patient_email_subject: string;
        patient_email_body: string;
        discharge_after_in_days: number;
    };
    episode_complete: {
        app_overlay_header: string;
        app_overlay_message: string;
        treatment_note: string;
        customer_note: string;
        patient_email_subject: string;
        patient_email_body: string;
        discharge_after_in_days: number;
    };
    onward_referral: {
        app_overlay_header: string;
        app_overlay_message: string;
        treatment_note: string;
        customer_note: string;
        patient_email_subject: string;
        patient_email_body: string;
    };
    other: {
        app_overlay_header: string;
        app_overlay_message: string;
        treatment_note: string;
        customer_note: string;
        patient_email_subject: string;
        patient_email_body: string;
        discharge_after_in_days: number;
    };
    [key: string]: {
        app_overlay_header: string;
        app_overlay_message: string;
        treatment_note: string;
        customer_note: string;
        patient_email_subject: string;
        patient_email_body?: string;
        discharge_after_in_days?: number;
    };
} = {
    failed_to_onboard: {
        app_overlay_header: "We've closed this referral for now",
        app_overlay_message:
            'Looks like you didn’t get a chance to start your exercise programme. No worries – life’s busy! We’ve sent you an email with what to do next if you’d still like to begin.',
        treatment_note:
            'Patient did not start Phio Engage within 4 weeks. Referral closed. Patient invited to complete a new referral via the Phio online assessment if support is still needed.',
        customer_note:
            'Discharged due to inactivity on Phio Engage after 4 weeks. Advised to re-refer via the online tool if further support is required.',
        patient_email_subject: 'Your Phio Engage Programme is Now Closed',
        patient_email_body: `We’re sorry you didn’t find the right moment to get started with Phio Engage. Already feeling better? Fantastic! \nPlease let us know so we can update your healthcare provider and close the loop on your referral.\nThank you for considering Phio Engage.`,
        discharge_after_in_days: 28
    },
    episode_closed: {
        app_overlay_header: "We've closed this referral for now",
        app_overlay_message:
            'It’s been a while since you last used Phio Engage, so we’ve closed your referral. No problem if you still need help - we’ve sent you an email with next steps.',
        treatment_note:
            'Patient has not interacted with Phio Engage in over 12 weeks. Referral closed due to inactivity. Patient advised to re-refer via the online assessment if further support is needed.',
        customer_note:
            'This patient was accepted on to Phio Engage to self manage. However, they have failed to complete a session in the past 12 weeks and have now been discharged from Phio.',
        patient_email_subject: 'Your Phio Engage File Has Been Closed',
        patient_email_body: `It’s been over 12 weeks since you last used Phio Engage, and we haven’t heard from you. We’re not sure how your recovery is going, so we’ve now closed your file with us. If you still need help managing your condition, please complete a new referral using the Phio online assessment. We’re here if you need us.`,
        discharge_after_in_days: 84
    },
    episode_complete: {
        app_overlay_header: 'Programme Complete',
        app_overlay_message:
            "Thanks for working through your Phio Engage sessions - we’ve now closed this programme. We’ve also sent you an email with what to do if you'd like to get back in touch.",
        treatment_note:
            'Programme marked as complete after confirmation with the patient. Patient discharged with option to provide recovery update or request further support if needed.',
        customer_note:
            'Programme marked as complete after confirmation with the patient. Patient discharged with option to provide recovery update or request further support if needed.',
        patient_email_subject: 'Your Phio Engage Programme is Now Complete',
        patient_email_body: `We’re pleased to let you know that your Phio Engage programme has now been marked as complete.Whether you're feeling fully recovered or have made good progress, we’re really glad we could support you on your journey.If you’d like to update us on how you're doing, or if you ever want to revisit your programme - just drop us a line at clinicalservices@eql.ai.Wishing you all the best in your continued recovery.`,
        discharge_after_in_days: 0
    },
    onward_referral: {
        app_overlay_header: "We've closed this referral for now",
        app_overlay_message:
            'Based on what you shared with us about your {{symptoms}}, we’ve agreed a different type of care is more suitable. You’ve now been referred to [new outcome] and discharged from Phio Engage.',
        treatment_note:
            'Patient reported {{symptoms}}, suggesting an alternative pathway is more appropriate. Referred to {{new outcome}} and discharged from Phio Engage.',
        customer_note:
            'This patient has reported {{relevant symptoms or issues}} and so has been escalated for [new outcome].',
        patient_email_subject: 'You’ve Been Referred for Further Support',
        patient_email_body: `Thanks for using Phio Engage. You mentioned [symptoms], so we’ve agreed that the best next step is for you to [new outcome]. You’ve now been discharged from Phio Engage and referred for the right support. If you have any questions, feel free to get in touch. Wishing you all the best with your recovery.`
    },
    other: {
        app_overlay_header: "We've closed this referral for now",
        app_overlay_message:
            'Because you mentioned {{issue}}, we have agreed to discharge you from Phio Engage.',
        treatment_note:
            'Patient has been discharged from Engage because they mentioned {{issue}}, we have agreed to discharge from Phio Engage with advice on next steps.',
        customer_note: 'This patient has has been discharged back in to your care.',
        patient_email_subject: 'Your Phio Engage Programme is Now Closed',
        patient_email_body: `Because you mentioned [issue], we have agreed to discharge you from Phio Engage.If you have any questions, feel free to get in touch. Wishing you all the best with your recovery.`,
        discharge_after_in_days: 0
    }
};

export default DefaultDischargeConfig;
